import React, { useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import EventList from './components/EventList';
import EventDetail from './components/EventDetail';
import Header from './components/Header';
import Footer from './components/Footer';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import './App.css';
import './styles/app-main.css';
import './styles/header.css';
import './styles/events.css';

// This will be replaced during build time with the actual timestamp
// Build 2 - Testing cache busting
const BUILD_TIME = process.env.REACT_APP_BUILD_TIME || Date.now();

function App() {
  useEffect(() => {
    // Add body class for fixed header spacing
    document.body.classList.add('has-fixed-header');

    // Prevent the browser from restoring scroll position on back/forward.
    // We manage scroll manually to keep UX consistent (e.g. returning from EventDetail → top of Events).
    const prevScrollRestoration = window.history.scrollRestoration;
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
    
    // Only check build time in production
    if (process.env.NODE_ENV === 'production') {
      const lastBuildTime = localStorage.getItem('lastBuildTime');
      console.log('Current build time:', BUILD_TIME);
      console.log('Last build time:', lastBuildTime);
      if (lastBuildTime && lastBuildTime !== BUILD_TIME.toString()) {
        console.log('Build time mismatch - forcing reload');
        // Clear all cached data
        localStorage.clear();
        // Force reload
        window.location.reload(true);
      }
      // Store current build time
      localStorage.setItem('lastBuildTime', BUILD_TIME.toString());
    }
    
    return () => {
      document.body.classList.remove('has-fixed-header');
      if ('scrollRestoration' in window.history) {
        window.history.scrollRestoration = prevScrollRestoration || 'auto';
      }
    };
  }, []);

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <div className="App">
        <Header />
        <Routes>
          <Route path="/" element={<EventList />} />
          {/* Keep dance-type paths like /tango, /salsa, etc. mapping to the list */}
          <Route path="/:dancePath" element={<EventList />} />
          {/* Event detail page with shareable URL; uses share-safe ID */}
          <Route path="/event/:shareId" element={<EventDetail />} />
        </Routes>
        <Footer />
      </div>
    </LocalizationProvider>
  );
}

export default App;
